import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel } from '../../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AllocationViewRestoreActionService {
  constructor(private http: WrapperHttpService) {}

  uliRestore(actionIdentifier: AllocationViewActionIdentifierModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Uli}${AllocationViewEndpoint.Restore}`;

    return this.http.withLoading().post<void>(url, actionIdentifier);
  }
}
